/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Apartment_NumberInputs */

const cs_form_apartment_number = /** @type {(inputs: Form_Apartment_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo bytu`)
};

const en_form_apartment_number = /** @type {(inputs: Form_Apartment_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartment number`)
};

/**
* | output |
* | --- |
* | "Apartment number" |
*
* @param {Form_Apartment_NumberInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_apartment_number = /** @type {((inputs?: Form_Apartment_NumberInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Apartment_NumberInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_apartment_number(inputs)
	return cs_form_apartment_number(inputs)
});